<script>
export default {
  name: 'RatingGlobalPlan',
  props: {
    reviews: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      rate: [5, 4, 3, 2, 1]
    }
  },
  methods: {
    getNumberReview (index) {
      let rate = 0
      Object.values(this.reviews).map(review => {
        rate += review.note === index ? 1 : 0
      })
      return rate
    },
    getPourcent (index) {
      const rate = this.getNumberReview(index)
      if (rate === 0) {
        return '0%'
      }
      return `${rate / this.reviews.length * 100}%`
    }
  }
}
</script>

<template>
  <div class="mt-6 min-w-0 flex-1 space-y-3 sm:mt-0">
    <div v-for="number in rate" :key="number" class="flex items-center gap-2">
      <p class="w-2 shrink-0 text-start text-sm font-medium leading-none text-gray-900 dark:text-white">
        {{ number }}
      </p>
      <i class="fa-solid fa-star text-yellow-300"></i>
      <div class="h-1.5 w-80 rounded-full bg-gray-200">
        <div class="h-1.5 rounded-full bg-yellow-300" :style="{ width: getPourcent(number) }"></div>
      </div>
      <div class="w-8 shrink-0 text-right text-sm font-medium leading-none text-primary-700 hover:underline sm:w-auto sm:text-left">
        {{ getNumberReview(number) }}
        <span class="hidden sm:inline">
          reviews
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>